import { useContext, useMemo } from 'react';
import { TagContext } from '../../../../Tag.context';
export const useColor = () => {
    const { variant } = useContext(TagContext);
    const color = useMemo(() => {
        if (!variant)
            return 'primary-600';
        return {
            primary: 'primary-600',
            danger: 'danger-600',
            neutral: 'black',
        }[variant];
    }, [variant]);
    return color;
};
